import { RATING_BADGE_TEXTS } from '@/shared/config/texts';

export type RatingTone = 'excellent' | 'good' | 'average' | 'low' | 'none';

const RATING_FRACTION_DIGITS = 1;

const RATING_TONE_THRESHOLDS: readonly { minRating: number; tone: RatingTone }[] = [
  { minRating: 4, tone: 'excellent' },
  { minRating: 3, tone: 'good' },
  { minRating: 2, tone: 'average' },
];

export function getRatingTone(rating: number | null): RatingTone {
  if (rating === null) return 'none';

  return RATING_TONE_THRESHOLDS.find(({ minRating }) => rating >= minRating)?.tone ?? 'low';
}

export function formatRating(rating: number | null): string {
  if (rating === null) return RATING_BADGE_TEXTS.empty;

  return rating.toFixed(RATING_FRACTION_DIGITS);
}
